import React from "react";
import { Typography } from "@mui/material";
import GreetingsRoot from "./GreetingStep.styles";

export const GreetingsStep = (props: React.DetailedHTMLProps<Omit<React.HTMLAttributes<HTMLDivElement>, "children">, HTMLDivElement>) => (
    <GreetingsRoot {...props}>
        <Typography variant="h5" component="h1" color="white" textAlign="center">
            Olá, seja bem vindo(a) ao Consulta MEI
        </Typography>
        <Typography variant="h6" component="h2" color="white" textAlign="center" fontWeight={200}>
            Clique para iniciar o atendimento gratuito
        </Typography>
    </GreetingsRoot>
);

export default GreetingsStep;
